import { t } from 'i18next';
import { IFounder } from 'PDF/pages/AboutTheCompany/types';
export const orderedTableRows = [
  'companyName',
  'legalStructure',
  'companyIndustry',
  'numberOfEmployees',
  'address',
  'registrationDate',
  'email',
  'phone',
  'websiteUrl',
  'contactPerson',
  'socialNetworks',
  'listOfFounders',
] as const;

export const formatFounderInfo = (founders: IFounder[], isExamplePage: boolean = false): string[] => {
  return founders.map(
    (founder) =>
      `${founder.firstName} ${founder.lastName} (${isExamplePage ? 'share in the company' : t('pdfPages.mappings.aboutCompany.shareInCompany')} - ${founder.share}%)`,
  );
};

export const formatContactPersonData = (contactPersonData: (string | undefined)[]) => {
  return contactPersonData.filter(Boolean).join(', ');
};

export const getPriorityForExamplePage = (priority: string) => {
  if (priority === 'Hoch' || priority === 'Високий') {
    return 'High';
  } else if (priority === 'Mittel' || priority === 'Середній') {
    return 'Medium';
  } else if (priority === 'Niedrig' || priority === 'Низький') {
    return 'Low';
  } else {
    return '';
  }
};
